export default "__VITE_ASSET__DXL_z$i___"